import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { RootState, useDispatch, useSelector } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import { editTextReset } from 'src/store/modules/editText';
import {
  buttonsReset,
  editBtnColor,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnPreFontSize,
  editBtnText
} from 'src/store/modules/buttons';
import {
  imageReset,
  editBgImage,
  editRadius,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import setInitValue from 'src/utils/setInitValue';
import { changeText } from 'src/utils/changeText';
import { changeEnter } from 'src/utils/changeEnter';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/SlideModalRoundTracking';

const initViewValues = {
  currentIndex: 0,
  bg: 'color',
  bgImage: {
    background: '',
    multi_image: [
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp'
    ]
  },
  bgColor: {
    background: '#000000'
  },
  radius: { background: 16, multi_image: 150 },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },

  text: {
    multi_title: ['SALE UP TO 30%', 'SALE UP TO 40%', 'SALE UP TO 50%'],
    multi_sub_title: [
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members.',
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members.',
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members.'
    ]
  },
  fontSize: { multi_title: 1.25, multi_sub_title: 0.75 },
  fontWeight: { multi_title: 700, multi_sub_title: 400 },
  color: { multi_title: '#ffffff', multi_sub_title: '#ffffff' },
  fontFamily: { multi_title: 'Montserrat', multi_sub_title: 'Montserrat' },
  textAlign: { multi_title: 'center', multi_sub_title: 'center' },

  btnText: {
    multi_left_button: [
      'Don’t ask again 1',
      'Don’t ask again 2',
      'Don’t ask again 3'
    ],
    multi_right_button: ['Close 1', 'Close 2', 'Close 3']
  },
  btnBgColorR: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorG: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorB: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorA: { multi_left_button: 0, multi_right_button: 0 },
  btnFontSize: { multi_left_button: 0.75, multi_right_button: 0.75 },
  btnFontWeight: { multi_left_button: 600, multi_right_button: 600 },
  btnColor: { multi_left_button: '#828282', multi_right_button: '#ffffff' },
  btnFontFamily: {
    multi_left_button: 'Montserrat',
    multi_right_button: 'Montserrat'
  },
  btnAgain: {
    type: 'none',
    multi_left_button: "don't show"
  }
};

const SlideModalRound: FC = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const contentsSliderRef = useRef<any>(null);

  const clientName = useSelector(
    (state: RootState) => state.client.userCompany
  );
  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          if (
            customValues?.bgImage &&
            customValues?.text &&
            customValues?.btnText
          ) {
            setInitValue(dispatch, customValues);
          } else {
            setValue(
              dispatch,
              customValues,
              { ...initViewValues, ...initTrackingValues },
              clientName
            );
          }
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
    };
  }, []);

  const modalLeftUrl = 'https://i.ibb.co/xL684x8/modal-left.png';
  const modalRightUrl = 'https://i.ibb.co/89XNkSx/modal-right.png';

  const style = `
  @Font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @Font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @Font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonFontURL});
  }
  @Font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonFontURL});
  }
  .root_view {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
    display: flex;
    justify-content: center;
    
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .modal_wrapper {
      width: calc(100% - 76px);
      
      display: flex;
      flex-direction: column;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .contents_wrapper {
      padding: 0 1rem;
      margin: 2rem 0 1rem 0;
      height: 6.5rem;
    }
    .contents_box {
      height: 6.5rem;
    }
    .contents_box .title {
      width: 100%;
      height: 2rem;
      margin-bottom: 0.5rem;

      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 4rem;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title_inner {
      width: 100%;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      
      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .slick_page {
      padding: 0.25rem 1rem;
      position: absolute;
      left: 50%;
      bottom: 4rem;
      transform: translate(-50%, 0%);

      display: flex;
      gap: 0.25rem;

      color: #fff;
      font-family: Roboto;
      font-size: 0.875rem;
      font-weight: 500;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      aspect-ratio: 1;
      outline: none;
    }
    .slick_wrapper .slick-list {
      overflow: hidden;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0 0;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }

    .slick-prev {
      width: 1.5rem;
      height: 3rem;

      z-index: 999;
      left: 0;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-prev:before {
      display: none;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-prev:hover {
      opacity: 1;
      display: block;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next {
      width: 1.5rem;
      height: 3rem;

      z-index: 999;
      right: 0;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next:before {
      display: none;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next:hover {
      opacity: 1;
      display: block;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }

    .btn_wrapper {
      height: 3rem;
      padding: 0.5rem 1rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .btn_wrapper button {
      border: 0;
      background-color: transparent;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };

      text-align: left;
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };

      text-align: right;
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }
  }
  `;

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    contentsSliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  const settings = {
    arrows: true,
    infinite: true,
    dots: false,
    speed: 300,
    touchThreshold: 300
  };

  const contentsSettings = {
    arrows: false,
    dots: false,
    fade: true,
    speed: 300,
    swipe: false
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="modal_wrapper">
          <div className="contents_wrapper">
            <Slider {...contentsSettings} ref={contentsSliderRef}>
              {text?.multi_title?.map((data: any, idx: number) => (
                <div key={idx} className="contents_box">
                  <div className="title">
                    <div className="title_inner">
                      {changeEnter(text?.multi_title?.[idx])}
                    </div>
                  </div>
                  <div className="sub_title">
                    <div className="sub_title_inner">
                      {changeEnter(text?.multi_sub_title?.[idx])}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="slick_wrapper">
            <Slider
              {...settings}
              ref={sliderRef}
              afterChange={index => {
                dispatch(editCurrentIndex(index));
                contentsSliderRef.current.slickGoTo(index);
              }}
            >
              {bgImage?.multi_image?.map((data: any, idx: number) => (
                <div key={idx}>
                  <img
                    src={data && data !== '' ? data : modalSlickAlt}
                    alt=""
                  />
                </div>
              ))}
            </Slider>
            {bgImage?.multi_image?.length !== 1 && (
              <div className="slick_page">
                <span>{currentIndex + 1}</span>
                <span className="slash">/</span>
                <span>{bgImage?.multi_image?.length}</span>
              </div>
            )}
          </div>
          <div className="btn_wrapper">
            <button className="style01">
              {btnText?.multi_left_button?.[currentIndex]}
            </button>
            <button className="style02">
              {btnText?.multi_right_button?.[currentIndex]}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const setValue = (
  dispatch: any,
  values: any,
  initViewValuess: any,
  clientName: any
) => {
  // console.log(values);
  // console.log('test');
  // dispatch(editBgColor(values?.bgColor));
  const MultiBackground = values?.imageName?.map(
    (data: any) => `https://image.inappmessage.com/${clientName}/${data}`
  );
  dispatch(
    editBgImage({
      multi_image: MultiBackground
    })
  );
  //  dispatch(editBgImageBlur(values?.bgImageBlur));
  dispatch(editDeeplink({ multi_image: values?.newDeepLink }));
  dispatch(
    editRadius({
      ...initViewValuess?.radius,
      ...{ background: values?.newImgRadius }
    })
  );

  // dispatch(editText(values?.text));
  // dispatch(editPreFontSize(values?.fontSize));
  // dispatch(editFontSize(values?.fontSize));
  // dispatch(editFontWeight(values?.fontWeight));
  // dispatch(editColor(values?.color));
  // dispatch(editFontFamily(values?.fontFamily));
  // dispatch(editTextAlign(values?.textAlign));

  dispatch(
    editBtnText({
      multi_left_button: [
        changeText(values?.newBtnText),
        changeText(values?.newBtnText),
        changeText(values?.newBtnText)
      ],
      multi_right_button: [
        changeText(values?.newCloseText),
        changeText(values?.newCloseText),
        changeText(values?.newCloseText)
      ]
    })
  );
  dispatch(
    editBtnPreFontSize({
      multi_left_button: values?.newBtnFontSize / 16,
      multi_right_button: values?.newCloseFontSize / 16
    })
  );
  dispatch(
    editBtnFontSize({
      multi_left_button: values?.newBtnFontSize / 16,
      multi_right_button: values?.newCloseFontSize / 16
    })
  );
  dispatch(
    editBtnFontWeight({
      multi_left_button: values?.newBtnFontWeight,
      multi_right_button: values?.newCloseFontWeight
    })
  );
  dispatch(
    editBtnColor({
      multi_left_button: values?.newBtnTextColor,
      multi_right_button: values?.newCloseTextColor
    })
  );
  //     dispatch(
  //       editBtnBgColor(
  //         values?.btnBgColorR,
  //         values?.btnBgColorG,
  //         values?.btnBgColorB,
  //         values?.btnBgColorA
  //       )
  //     );
  //     dispatch(editBtnFontFamily(values?.btnFontFamily));
  //     dispatch(editBtnTextAlign(values?.btnTextAlign));
};

export default SlideModalRound;
